import { AtomButton } from '../Button';
import { Separator } from '../Divider';
import { Disclosure, DisclosureChevron, DisclosurePanel, DisclosureTrigger } from './Disclosure';

/**
 * Disclosure section with a lined header that can be expanded to show the children.
 * It should be used to show advanced options that are not always needed.
 */
export function HiddenDisclosureSection(props: {
    id?: string;
    labels: {
        show: string;
        hide: string;
    };
    children: React.ReactNode;
}) {
    const { id, labels, children } = props;
    return (
        <Disclosure id={id}>
            {({ isExpanded }) => (
                <div className="flex w-full flex-col">
                    <div className="flex items-center gap-2">
                        <DisclosureTrigger>
                            <AtomButton className="group flex w-full max-w-fit items-start gap-2 rounded-sm py-2 text-left text-muted hover:text-base focus-visible:focus-ring">
                                <div className="flex items-center gap-0.5">
                                    {isExpanded ? labels.hide : labels.show}
                                </div>
                                <DisclosureChevron className="mr-0.5 size-4" />
                            </AtomButton>
                        </DisclosureTrigger>
                        <Separator className="my-1 w-full border-t" />
                    </div>
                    <DisclosurePanel className="flex flex-col">
                        <div className="flex flex-col">{children}</div>
                    </DisclosurePanel>
                </div>
            )}
        </Disclosure>
    );
}
